import { createGtm } from '@gtm-support/vue-gtm'

function getCookieConsent() {
    const cookieStatus = localStorage.getItem('cookie-consent')

    if (cookieStatus && cookieStatus === 'accepted') {
        return true
    }

    return false
}

export default defineNuxtPlugin((nuxtApp) => {
    const config = useRuntimeConfig()
    const gtmContainerId = config.public.gtmContainerId
    const debug = !!config.public.devMode
    const cookieConsent = useCookie('visuado-cookie-consent')
    nuxtApp.vueApp.use(
        createGtm({
            id: gtmContainerId,
            defer: false,
            compatibility: false,
            enabled: cookieConsent.value === 'accepted' ? true : false,
            debug,
            loadScript: true,
            vueRouter: useRouter(),
            trackOnNextTick: false
        })
    )
})
